import { connect } from 'react-redux';
import { setIsNavHidden } from '../navigationSlice';
import AddMenu from './AddMenu';

const mapState = () => ({});

const mapDispatch = {
  setIsNavHidden,
};

export default connect(mapState, mapDispatch)(AddMenu);
